/** Contextual empty state — ONE mode (Design System 2.0, 2026-10, Phase 1): one line + one
 * action, nothing else. A real primary action is shown ONLY when one genuinely exists (never
 * a fake/dead button for read-only-from-Notion entities like Meetings). The old `compact`
 * prop is accepted-but-ignored for backward compatibility (every existing caller still works
 * unchanged, there is just one visual shape now instead of two). */
export function EmptyState({ title = "Nothing here yet", hint, actionLabel, onAction, testId }) {
  return (
    <div className="px-5 py-3 flex items-center justify-between gap-3 flex-wrap" data-testid={testId}>
      <span className="text-sm text-faint">
        {title}{hint && <span className="ml-1.5 text-faint/80">{hint}</span>}
      </span>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          data-testid={testId ? `${testId}-action` : undefined}
          className="shrink-0 text-xs font-semibold text-ink-soft hover:text-gold-text"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
